import React, { createContext, useContext, useState } from 'react';

const DialogContext = createContext(null);

export const useCustomDialog = () => {
    return useContext(DialogContext);
};

export const DialogProvider = ({ children }) => {
    const [state, setState] = useState({
        isOpen: false,
        message: '',
        title: '',
        type: 'info',
        isConfirm: false,
        resolve: null
    });

    const alert = (message, title = 'Alert', type = 'info') => {
        return new Promise((resolve) => {
            setState({
                isOpen: true,
                message,
                title,
                type,
                isConfirm: false,
                resolve
            });
        });
    };

    const confirm = (message, title = 'Are you sure?', type = 'danger') => {
        return new Promise((resolve) => {
            setState({
                isOpen: true,
                message,
                title,
                type,
                isConfirm: true,
                resolve
            });
        });
    };

    const handleClose = (value) => {
        if (state.resolve) {
            state.resolve(value);
        }
        setState({
            isOpen: false,
            message: '',
            title: '',
            type: 'info',
            isConfirm: false,
            resolve: null
        });
    };

    const getIcon = () => {
        switch (state.type) {
            case 'success':
                return 'fa-check-circle text-success';
            case 'danger':
                return 'fa-exclamation-triangle text-danger';
            case 'warning':
                return 'fa-exclamation-circle text-warning';
            default:
                return 'fa-info-circle text-info';
        }
    };

    return (
        <DialogContext.Provider value={{ alert, confirm }}>
            {children}
            {state.isOpen && (
                <div className="custom-dialog-overlay" onClick={() => handleClose(false)}>
                    <div className={`custom-dialog-box animate-pop`} onClick={(e) => e.stopPropagation()}>
                        <div className="custom-dialog-header">
                            <div className="custom-dialog-icon-wrapper">
                                <i className={`fas ${getIcon()}`}></i>
                            </div>
                            <h3 className="custom-dialog-title">{state.title}</h3>
                        </div>
                        <div className="custom-dialog-body">
                            <p>{state.message}</p>
                        </div>
                        <div className="custom-dialog-actions">
                            {state.isConfirm ? (
                                <>
                                    <button 
                                        className="custom-dialog-btn cancel-btn"
                                        onClick={() => handleClose(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button 
                                        className={`custom-dialog-btn confirm-btn ${state.type}`}
                                        onClick={() => handleClose(true)}
                                    >
                                        Confirm
                                    </button>
                                </>
                            ) : (
                                <button 
                                    className="custom-dialog-btn confirm-btn info"
                                    onClick={() => handleClose(true)}
                                >
                                    OK
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </DialogContext.Provider>
    );
};
